import React from "react";
import { 
  Grid, 
  Typography, 
  Box, 
  Link,
  useTheme 
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Assignment, Business, Group, RocketLaunch } from "@mui/icons-material";
import logoImgOnlyS from '../assest/logo/logo.svg'
export default function Homepage() {
  const theme = useTheme();
  const toSlug = (str) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

const sections = [
  {
    icon: <RocketLaunch fontSize="medium" />,
    title: "Get started",
    items: [
      "Group","Dashboard","organisation By Subdomain","Authentication Login","my test"
    ].map((label) => ({ id: toSlug(label), label })),
  },
  {
    icon: <Group fontSize="medium" />,
    title: "New Ticket",
    items: [
      "Ticket Creation", "Ticket Update","Ticket Log By ID","Get Ticket Timeline","Ticket Drag and drop in Status View","Ticket update to Priority",
      "Get All TicketType","Get TicketType By ID",
      "Update Ticket Type","Ticket Detail"
    ].map((label) => ({ id: toSlug(label), label })),
  },
  {
    icon: <Assignment fontSize="medium" />,
    title: "CMDB",
    items: ["Assets (CMDB)", "Asset type","Asset status","Category Creation"].map((label) => ({ id: toSlug(label), label })),
  },
  // {
  //   icon: <Business fontSize="medium" />,
  //   title: "Organiztion",
  //   items: ["Organiztion Login", "Knowledge Base", "SystemManagement"].map((label) => ({ id: toSlug(label), label })),
  // },
  {
    icon: <Business fontSize="medium" />,
    title: "TicketManagement",
    items: ["TicketTask", 
      "Ticket notification",
      "Ticket Drag and drop in Status View",
      "Ticket update to Priority"
      ,
      "SystemManagement"].map((label) => ({ id: toSlug(label), label })),
  },
  {
    icon: <Business fontSize="medium" />,
    title: "ContactManagement",
    items: ["Location", "Contacts", "ContactOrganisationType", "Department"].map((label) => ({ id: toSlug(label), label })),
  },
  {
    icon: <Business fontSize="medium" />,
    title: "Knowledge Base",
    items: ["article", "Report"].map((label) => ({ id: toSlug(label), label })),
  },
  {
    icon: <Business fontSize="medium" />,
    title: "SystemManagement",
    items: ["Workflow configuration", "survey","SSP configuration","Source","Interfaces"].map((label) => ({ id: toSlug(label), label })),
  },
   {
    icon: <Business fontSize="medium" />,
    title: "User management",
    items: ["Groups",
"Roles",
"Ranking",
"Agents",
"Agent groups","Licence"].map((label) => ({ id: toSlug(label), label })),
  },
];


  return (
    <Box sx={{ 
      bgcolor: 'background.default', 
      color: 'text.primary', 
      minHeight: '100vh',
      p: 4
    }}>
      <Box sx={{ 
        textAlign: 'center',
        mb: 6,
        color: 'text.primary'
      }}>
         <Box>
          <img src={logoImgOnlyS} alt="" width={300} sx={{color: 'text.secondary' }}/>
       
        <Typography>Help for wherever you are on your API  journey.</Typography>
      </Box>
        <Typography variant="subtitle1">
          Discover all our features
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {sections.map((section, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            < >
              <Box sx={{ 
                display: "flex", 
                alignItems: "center", 
                mb: 2,
              }}>
                {section.icon}
                <Typography variant="h6" component="h2" sx={{ ml: 1 }}>
                  {section.title}
                </Typography>
              </Box>
              
              <Box component="ul" sx={{ 
                pl: 0, 
                listStyle: "none",
                // color: 'text.secondary' 
              }}>
                {section.items.map((item) => (
                  <Box component="li" key={item.id} sx={{ py: 0.5 }}>
                    <Link
                      component={RouterLink}
                      to={`/section/${item.id}`}
                      underline="hover"
                      sx={{
                        color: 'inherit',
                        '&:hover': {
                          color: 'primary'
                        }
                      }}
                    >
                      {item.label}
                    </Link>
                  </Box>
                ))}
              </Box>
            </>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}